import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import * as routes from '../constants/Routes';
import { useAuth } from '../hooks/useAuth';
import { decodeSafedata } from '../utils/decodeSafeData';

export function PrivateRoute({ children }: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const { player, client } = useAuth();

  useEffect(() => {
    if (!player) navigate(`${routes.UNDERLINE}/${client.clientUrl}`);

    let playerAuthLocal = localStorage.getItem('@pwa:playerAuth');

    if (playerAuthLocal) {
      playerAuthLocal = decodeSafedata(playerAuthLocal);
    }

    const playerAuthparse = playerAuthLocal
      ? JSON.parse(JSON.parse(playerAuthLocal))
      : null;

    if (playerAuthparse) {
      const urlsGamified = ['/ranking'];
      const accessUrlGamified = urlsGamified.includes(location.pathname);

      const urlsInfluencer = [
        '/chooseInfluencer',
        '/congratulations',
        '/wellcomeinfluencer',
        '/followers',
        '/profileinfluencer',
        '/detailsInfluencerPlayer',
        '/forgotpasswordInfluencerPlayer',
        '/registergameinfluencers',
        '/validationCode',
      ];
      const accessUrlInfluencer = urlsInfluencer.includes(location.pathname);

      const urlsMgm = ['/prospects', `${routes.UNDERLINE}${routes.CORRETOR}`];
      const accessUrlMgm = urlsMgm.includes(location.pathname);

      if (!player) navigate(`${routes.UNDERLINE}/${client.clientUrl}`);

      if (player && !player.active) {
        return navigate(routes.USER_INACTIVE);
      }

      if (
        client &&
        client.isGamified &&
        client.isGamified !== 'true' &&
        accessUrlGamified
      ) {
        return navigate(routes.NOT_FOUND);
      }

      if (
        client &&
        client.isTeamCompetition &&
        client.isTeamCompetition !== 'true' &&
        accessUrlInfluencer
      ) {
        return navigate(routes.NOT_FOUND);
      }

      if (
        client &&
        client.mgmVinculated &&
        client.mgmVinculated !== 'true' &&
        accessUrlMgm
      ) {
        return navigate(routes.NOT_FOUND);
      }
    } else {
      return navigate(routes.NOT_FOUND);
    }
  }, []);

  if (
    player &&
    player.regional === 'sim' &&
    !player.acceptedPrivacyTerm &&
    location.pathname !== routes.EDIT_PROFILE
  ) {
    return <Navigate to={routes.EDIT_PROFILE} replace />;
  }

  return children;
}
